module.exports = __webpack_public_path__ + "img/top.3091cd22.svg";